import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './contexts/AppContext';
import { CategoriesProvider } from './contexts/CategoriesContext';
import { ToasterProvider } from './components/shared/Toaster';
import { ProtectedRoute, PublicRoute } from './routes/ProtectedRoute';
import { LoginPage } from './pages/auth/LoginPage';
import { AppLayout } from './components/layout/AppLayout';
import { DashboardPage } from './pages/dashboard/DashboardPage';
import { IncomesPage } from './pages/income/IncomesPage';
import { ExpensesPage } from './pages/expenses/ExpensesPage';
import { MonthlyPage } from './pages/monthly/MonthlyPage';
import { ComparePage } from './pages/compare/ComparePage';
import { ProjectsPage } from './pages/projects/ProjectsPage';
import { OwnersPage } from './pages/owners/OwnersPage';
import { CategoriesPage } from './pages/categories/CategoriesPage';

function App() {
  return (
    <BrowserRouter>
      <ToasterProvider>
        <AuthProvider>
          <CategoriesProvider>
            <Routes>
            <Route element={<PublicRoute />}>
              <Route path="/login" element={<LoginPage />} />
            </Route>

            <Route element={<ProtectedRoute />}>
              <Route element={<AppLayout />}>
                <Route index element={<DashboardPage />} />
                <Route path="incomes" element={<IncomesPage />} />
                <Route path="expenses" element={<ExpensesPage />} />
                <Route path="projects" element={<ProjectsPage />} />
                <Route path="owners" element={<OwnersPage />} />
                <Route path="categories" element={<CategoriesPage />} />
                <Route path="monthly" element={<MonthlyPage />} />
                <Route path="compare" element={<ComparePage />} />
              </Route>
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </CategoriesProvider>
        </AuthProvider>
      </ToasterProvider>
    </BrowserRouter>
  );
}

export default App;
